import React, { useState , useEffect, setErrors }from 'react';
import './App.css';
import DateTime from './comps/dateTime';
import DropdownStaff from './comps/dropdown';
import StaffModal from './comps/modal';
import AlertDismissible from './comps/fyi';

function App() {

  var [allStaff,setStaff] = useState('');
  var [specificStaff,setSpecificStaff] = useState([]);

  async function fetchData() {
      await fetch("https://mediumclocking.herokuapp.com/")
      .then(response => response.json())
      .then(response => {
          setStaff(response);            
          console.log("all staff" + typeof response[0]);
      })
      
      .catch(err => {
          setErrors(err)
          
      });
  }
  
  useEffect(() => {
  fetchData();
  return () => {
      console.log('unmounting...') 
      console.log(allStaff);
      
  }
  },[]);


  if(allStaff){
  return (
    <div className="App">
      <div className="overlay"></div>
        <div className="onTopLayer"> 


          <h1>Bob's Coffee Shop</h1>
          {/* {allStaff.map(person=>(<p>{person.name}</p>))} */}
          <DropdownStaff allStaff={allStaff} specificStaff={specificStaff} setSpecificStaff={setSpecificStaff} ></DropdownStaff>
          <DateTime></DateTime>
          <StaffModal allStaff={allStaff}></StaffModal>
          <AlertDismissible></AlertDismissible>
        </div>
    </div>
  )}else{
    return null}
}

export default App;

